export default {
  // home

  // ui
  entrar: "Entrar",
  play: "Reproducir",
  pause: "Pausar",
  subtitles: "Subtítulos",
  pantalla_completa: "Pantalla completa",
  salir_pantalla_completa: "Salir de pantalla completa",
  escena_completada: "Escena completada",
  // overlays
  r1_1: "A) Guardar a final de mes lo que le haya sobrado, como hasta ahora.",
  r1_2: "B) Aplicar el método del chaval de Dubái: cero planificación, cero cambios de hábitos y resultados espectaculares.",
  r1_3: "C) Hacer una aportación periódica: apartar una cantidad fija a principio de cada mes para invertir, antes de empezar a gastar.",

  r2_1: "A) Lo mismo que entonces, porque el dinero guardado en casa no se toca y conserva su valor.",
  r2_2: "B) Menos que entonces, porque los precios han ido subiendo año tras año. Ha perdido poder adquisitivo.",
  r2_3: "C) Más que entonces, porque el dinero que lleva tanto tiempo guardado se va revalorizando solo.",

  r3_1: "A) Porque tu vida ha cambiado: te has casado, has tenido hijos, te has comprado una casa...",
  r3_2: "B) Porque los seguros de vida caducan solo pasado un tiempo y hay que volver a firmarlos.",
  r3_3: "C) Porque cuanto más años lleves con el mismo, más barato te lo va poniendo la aseguradora.",

};
